(() => {
const assetUrl=key=>window.LunaAssetUrls[key];const esc=value=>String(value).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function homeBundles(data) {
  const grouped = new Map();
  data.products.forEach((product) => {
    if (!product.bundle_id) return;
    if (!grouped.has(product.bundle_id)) grouped.set(product.bundle_id, []);
    grouped.get(product.bundle_id).push(product);
  });
  const ordered = [...grouped].sort(([, a], [, b]) => Number(b.some(product => product.sku === 'PS2508249')) - Number(a.some(product => product.sku === 'PS2508249')));
  return ordered.map(([id, products]) => {
    const lead = products.find((product) => product.product_type === 'Necklace') || products[0];
    const name = lead.title.replace(/\s+(Necklace|Bracelet|Drop Earrings)$/, '');
    return { id, name, products, image: data.visual_refinement.bundle_model_assets[id] };
  });
}


function homeFeaturedSeries(data, category = 'All') {
  const sku = { All: 'PS2508241', Necklace: 'PS2508312', Bracelet: 'PS2508249', Earrings: 'PS2508241' }[category];
  return homeBundles(data).find(bundle => bundle.products.some(product => product.sku === sku));
}


function bindHomeInteractions() {
  const homePage = document.querySelector('.home-v17');
  if (!homePage) return;
  const track = homePage.querySelector('.home-explore-products');
  const cards = [...track.querySelectorAll('[data-home-sku]')];
  const data = window.siteData;
  const products = new Map(data.products.map((product) => [product.sku, product]));
  const bundles = homeBundles(data);
  const filters = [...homePage.querySelectorAll('[data-home-filter]')];
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobileRail = window.matchMedia('(max-width: 639px)');
  const desktopCards = [...cards];
  const mobileLead = cards.find(card => card.querySelector('a[href="/products/citrine-baroque-pearl-bracelet"]'));
  const orderProducts = () => {
    if (!mobileLead) return;
    const ordered = mobileRail.matches ? [mobileLead, ...desktopCards.filter(card => card !== mobileLead)] : desktopCards;
    cards.splice(0, cards.length, ...ordered);
    ordered.forEach(card => track.append(card));
  };
  orderProducts();
  mobileRail.addEventListener('change', () => {
    orderProducts();
    showProducts(filters.find(button => button.getAttribute('aria-pressed') === 'true')?.dataset.homeFilter || 'All');
  });
  const rail = track.closest('.home-explore-rail');
  const previousProduct = homePage.querySelector('[data-home-slide="-1"]');
  const nextProduct = homePage.querySelector('[data-home-slide="1"]');
  let requestedRailPosition = null;
  let railSettleTimer;
  const railPositions = () => {
    const box = track.getBoundingClientRect();
    const end = Math.max(0, track.scrollWidth - track.clientWidth);
    return cards.filter(card => !card.hidden).map(card => {
      const rect = card.getBoundingClientRect();
      const start = rect.left - box.left + track.scrollLeft;
      return { card, left: Math.max(0, Math.min(end, start - (mobileRail.matches ? (track.clientWidth - rect.width) / 2 : 0))) };
    });
  };
  const nearestRailPosition = (positions, left = track.scrollLeft) => positions.reduce((best, item) => Math.abs(item.left - left) < Math.abs(best.left - left) ? item : best, positions[0]);
  const updateArrows = () => {
    const end = Math.max(0, track.scrollWidth - track.clientWidth);
    previousProduct.disabled = end < 2 || track.scrollLeft <= 2;
    nextProduct.disabled = end < 2 || track.scrollLeft >= end - 2;
    const positions = railPositions();
    if (!positions.length) return;
    const active = nearestRailPosition(positions);
    cards.forEach(card => {
      const current = String(card === active.card);
      if (card.dataset.railCurrent !== current) card.dataset.railCurrent = current;
    });
    const picture = active.card.querySelector('.luna-card-media').getBoundingClientRect();
    const bounds = rail.getBoundingClientRect();
    rail.style.setProperty('--rail-control-y', `${picture.top - bounds.top + picture.height / 2}px`);
    rail.style.setProperty('--rail-control-left', `${mobileRail.matches ? 3 : 8}px`);
    rail.style.setProperty('--rail-control-right', `${mobileRail.matches ? 3 : 8}px`);
  };
  const moveProducts = direction => {
    const positions = railPositions();
    if (!positions.length) return;
    const end = Math.max(0, track.scrollWidth - track.clientWidth);
    const current = requestedRailPosition ?? track.scrollLeft;
    let destination;
    if (mobileRail.matches) {
      const index = positions.indexOf(nearestRailPosition(positions, current));
      destination = positions[Math.max(0, Math.min(positions.length - 1, index + direction))].left;
    } else {
      const goal = Math.max(0, Math.min(end, current + direction * track.clientWidth));
      destination = nearestRailPosition(positions, goal).left;
    }
    requestedRailPosition = destination;
    track.scrollTo({ left: destination, behavior: reduceMotion.matches ? 'instant' : 'smooth' });
    updateArrows();
  };
  function showProducts(category = 'All') {
    cards.forEach((card) => {
      const product = products.get(card.dataset.homeSku);
      card.hidden = category !== 'All' && product.product_type !== category;
    });
    filters.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.homeFilter === category)));
    requestedRailPosition = null;
    track.scrollTo({ left: 0, behavior: 'instant' });
    const label = category === 'All' ? 'All jewelry' : filters.find((button) => button.dataset.homeFilter === category).textContent;
    homePage.querySelector('[data-home-filter-status]').textContent = `Showing ${label}`;
    requestAnimationFrame(updateArrows);
  }
  filters.forEach((button) => button.addEventListener('click', () => showProducts(button.dataset.homeFilter)));
  homePage.querySelectorAll('[data-home-slide]').forEach(button => button.addEventListener('click', () => moveProducts(Number(button.dataset.homeSlide))));
  track.addEventListener('keydown', event => {
    if (event.target !== track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    if (event.key === 'Home' || event.key === 'End') {
      const left = event.key === 'Home' ? 0 : track.scrollWidth - track.clientWidth;
      requestedRailPosition = left;
      track.scrollTo({ left, behavior: reduceMotion.matches ? 'instant' : 'smooth' });
    } else moveProducts(event.key === 'ArrowRight' ? 1 : -1);
  });
  track.addEventListener('pointerdown', () => { requestedRailPosition = null; }, { passive: true });
  track.addEventListener('wheel', () => { requestedRailPosition = null; }, { passive: true });
  // Match native touch/trackpad scrolling with a mouse drag in either direction.
  let railDrag = null;
  let suppressRailClickUntil = 0;
  track.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
    railDrag = { id:event.pointerId, x:event.clientX, y:event.clientY, left:track.scrollLeft, active:false };
  });
  track.addEventListener('pointermove', event => {
    if (!railDrag || event.pointerId !== railDrag.id) return;
    if (event.buttons !== 1) { finishRailDrag(); return; }
    const dx = event.clientX - railDrag.x;
    if (!railDrag.active && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(event.clientY - railDrag.y)) {
      railDrag.active = true;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    }
    if (!railDrag.active) return;
    event.preventDefault();
    track.scrollTo({left:railDrag.left - dx, behavior:'instant'});
  });
  const finishRailDrag = () => {
    const completedDrag = railDrag;
    railDrag = null;
    if (completedDrag?.active) {
      suppressRailClickUntil = Date.now() + 350;
      if (track.hasPointerCapture(completedDrag.id)) track.releasePointerCapture(completedDrag.id);
    }
    track.classList.remove('is-dragging');
    updateArrows();
  };
  track.addEventListener('pointerup', finishRailDrag);
  track.addEventListener('pointercancel', finishRailDrag);
  track.addEventListener('lostpointercapture', finishRailDrag);
  track.addEventListener('dragstart', event => event.preventDefault());
  track.addEventListener('click', event => {
    if (Date.now() < suppressRailClickUntil) { event.preventDefault(); event.stopPropagation(); return; }
    if (!mobileRail.matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = event.target.closest('[data-home-sku]');
    if (!card || card.hidden || card.dataset.railCurrent !== 'false') return;
    const destination = railPositions().find(item => item.card === card);
    if (!destination) return;
    event.preventDefault();
    event.stopPropagation();
    requestedRailPosition = destination.left;
    track.scrollTo({ left: destination.left, behavior: reduceMotion.matches ? 'instant' : 'smooth' });
    updateArrows();
  }, true);
  track.addEventListener('scroll', () => {
    updateArrows();
    clearTimeout(railSettleTimer);
    railSettleTimer = setTimeout(() => { requestedRailPosition = null; }, 160);
  }, { passive: true });
  track.addEventListener('scrollend', () => { requestedRailPosition = null; updateArrows(); });
  new ResizeObserver(() => { requestedRailPosition = null; updateArrows(); }).observe(track);
  const seriesSelect = homePage.querySelector('[data-home-series]');
  const stack = homePage.querySelector('.bundle-stack');
  const stackCards = [...stack.querySelectorAll('[data-bundle-card]')];
  stackCards.forEach(card => {
    const image = card.querySelector('img');
    const fitCard = () => { if (image.naturalWidth) card.style.setProperty('--bundle-image-ratio', `${image.naturalWidth} / ${image.naturalHeight}`); };
    image.addEventListener('load', fitCard);
    fitCard();
  });
  const bundleFilters = [...homePage.querySelectorAll('[data-bundle-filter]')];
  let visibleBundles = bundles;
  let currentSeries = 0;
  const selectSeries = (index, replacePanel = true) => {
    currentSeries = (index % visibleBundles.length + visibleBundles.length) % visibleBundles.length;
    const bundle = visibleBundles[currentSeries];
    seriesSelect.value = bundle.id;
    const activeImage = stackCards.find(card => card.dataset.bundleCard === bundle.id)?.querySelector('img');
    const syncStackRatio = () => { if (seriesSelect.value === bundle.id && activeImage?.naturalWidth) stack.style.setProperty('--active-bundle-ratio', activeImage.naturalWidth / activeImage.naturalHeight); };
    syncStackRatio();
    if (activeImage && !activeImage.complete) activeImage.addEventListener('load', syncStackRatio, { once: true });
    stackCards.forEach((card) => {
      const position = visibleBundles.findIndex(item => item.id === card.dataset.bundleCard);
      let relative = (position - currentSeries + visibleBundles.length) % visibleBundles.length;
      if (relative > visibleBundles.length / 2) relative -= visibleBundles.length;
      card.dataset.position = position < 0 ? 'excluded' : relative === 0 ? 'active' : relative === -1 ? 'previous' : relative === 1 ? 'next' : relative < 0 ? 'before' : 'after';
      card.setAttribute('aria-current', String(position >= 0 && relative === 0));
      card.setAttribute('aria-hidden', String(position < 0 || Math.abs(relative) > 1));
      if (position >= 0 && Math.abs(relative) <= 1) card.querySelector('img').loading = 'eager';
    });
    if (replacePanel) {
      const details = homePage.querySelector('#home-bundle-details');
      details.innerHTML = window.LunaCommerce.bundlePanel(bundle);
      if (!reduceMotion.matches) details.animate([{opacity:.35,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}], {duration:240,easing:'ease-out'});
    }
    homePage.querySelector('[data-home-bundle-status]').textContent = `${bundle.name}, ${currentSeries + 1} of ${visibleBundles.length}`;
  };
  seriesSelect.addEventListener('change', () => selectSeries(visibleBundles.findIndex(item => item.id === seriesSelect.value)));
  homePage.querySelectorAll('[data-series-step]').forEach(button => button.addEventListener('click', () => selectSeries(currentSeries + Number(button.dataset.seriesStep))));
  bundleFilters.forEach(button => button.addEventListener('click', () => {
    const previousId = visibleBundles[currentSeries].id;
    visibleBundles = bundles.filter(bundle => button.dataset.bundleFilter === 'all' || bundle.products.length === Number(button.dataset.bundleFilter));
    seriesSelect.innerHTML = visibleBundles.map(bundle => `<option value="${esc(bundle.id)}">${esc(bundle.name)}</option>`).join('');
    bundleFilters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    selectSeries(Math.max(0, visibleBundles.findIndex(bundle => bundle.id === previousId)));
  }));
  stack.addEventListener('keydown', event => {
    if (event.target !== stack || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    selectSeries(currentSeries + (event.key === 'ArrowRight' ? 1 : -1));
  });
  let pointer = null;
  let blockClickUntil = 0;
  const resetDrag = () => { stack.classList.remove('is-dragging'); stack.style.removeProperty('--drag-x'); pointer = null; };
  stack.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.button !== 0 || event.target.closest('[data-series-step]')) return;
    pointer = {id:event.pointerId,x:event.clientX,y:event.clientY,dx:0,dragging:false};
  });
  stack.addEventListener('pointermove', event => {
    if (!pointer || pointer.id !== event.pointerId) return;
    const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
    if (!pointer.dragging && Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)*1.2) {
      pointer.dragging = true;
      stack.setPointerCapture(event.pointerId);
      stack.classList.add('is-dragging');
    }
    if (!pointer.dragging) return;
    event.preventDefault();
    pointer.dx = dx;
    stack.style.setProperty('--drag-x', `${Math.max(-110,Math.min(110,dx))}px`);
  });
  stack.addEventListener('pointerup', event => {
    if (!pointer || pointer.id !== event.pointerId) return;
    const {dx,dragging} = pointer;
    if (stack.hasPointerCapture(event.pointerId)) stack.releasePointerCapture(event.pointerId);
    resetDrag();
    if (dragging) {
      blockClickUntil = Date.now() + 350;
      if (Math.abs(dx) >= 45) selectSeries(currentSeries + (dx < 0 ? 1 : -1));
    }
  });
  stack.addEventListener('pointercancel', resetDrag);
  stack.addEventListener('click', event => {
    if (Date.now() < blockClickUntil) { event.preventDefault(); event.stopPropagation(); return; }
    const card = event.target.closest('[data-bundle-card]');
    if (card && card.dataset.position !== 'active') selectSeries(visibleBundles.findIndex(bundle => bundle.id === card.dataset.bundleCard));
  });
  const desktopBundles = [...bundles];
  const mobileFirstBundle = bundles.find(bundle => bundle.products.some(product => product.sku === 'PS2508312'));
  const orderBundles = (initial = false) => {
    const ordered = mobileRail.matches && mobileFirstBundle ? [mobileFirstBundle, ...desktopBundles.filter(bundle => bundle !== mobileFirstBundle)] : desktopBundles;
    bundles.splice(0, bundles.length, ...ordered);
    const category = bundleFilters.find(button => button.getAttribute('aria-pressed') === 'true')?.dataset.bundleFilter || 'all';
    visibleBundles = bundles.filter(bundle => category === 'all' || bundle.products.length === Number(category));
    seriesSelect.innerHTML = visibleBundles.map(bundle => `<option value="${esc(bundle.id)}">${esc(bundle.name)}</option>`).join('');
    selectSeries(0, !initial || mobileRail.matches);
  };
  orderBundles(true);
  mobileRail.addEventListener('change', () => orderBundles());

  const setMotion = (paused) => homePage.classList.toggle('motion-paused', paused);
  setMotion(reduceMotion.matches);
  reduceMotion.addEventListener('change', (event) => setMotion(event.matches));
  updateArrows();
}


function bindAboutInteractions() {
  const page = document.querySelector('.about-v18');
  if (!page) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const syncSystemPreference = () => page.classList.toggle('about-motion-paused', reducedMotion.matches);
  syncSystemPreference();
  reducedMotion.addEventListener('change', syncSystemPreference);
}


function bindInteractions() {
  bindHomeInteractions();
  bindAboutInteractions();
  const menuButton = document.querySelector('.menu-button');
  menuButton?.addEventListener('click', () => {
    const nav = menuButton.closest('.nav-list');
    const open = nav.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.textContent = open ? 'Close' : 'Menu';
    if (document.body.matches('.route-home, .route-about')) menuButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  document.querySelectorAll('[data-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.filter;
      document.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('active', item === button));
      const cards = [...document.querySelectorAll('[data-product-type]')];
      let count = 0;
      cards.forEach((card) => {
        const visible = filter === 'All' || card.dataset.productType === filter;
        card.hidden = !visible;
        if (visible) count += 1;
      });
      const countNode = document.querySelector('[data-count]');
      if (countNode) countNode.textContent = `${count} ${count === 1 ? 'piece' : 'pieces'}`;
    });
  });

  document.querySelectorAll('[data-scroll-gallery]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector(`[data-gallery-index="${button.dataset.scrollGallery}"]`);
      if (!target) return;
      const feed = target.closest('.pdp-gallery-feed');
      const horizontal = window.matchMedia('(max-width: 900px)').matches;
      const targetRect = target.getBoundingClientRect();
      const feedRect = feed.getBoundingClientRect();
      feed.scrollTo({
        left: horizontal ? feed.scrollLeft + targetRect.left - feedRect.left : 0,
        top: horizontal ? 0 : feed.scrollTop + targetRect.top - feedRect.top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    });
  });

  const galleryItems = [...document.querySelectorAll('[data-gallery-index]')];
  if (galleryItems.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      document.querySelectorAll('[data-scroll-gallery]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.scrollGallery === visible.target.dataset.galleryIndex)));
    }, { root: document.querySelector('.pdp-gallery-feed'), threshold: [0.2, 0.5, 0.8] });
    galleryItems.forEach((item) => observer.observe(item));
  }


}
function bindNavigation() {
  const menus = [...document.querySelectorAll('.shop-menu, .mobile-menu')];
  menus.forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) menus.filter(other => other !== menu).forEach(other => { other.open = false; });
  }));
  document.addEventListener('click', event => {
    menus.forEach(menu => { if (!menu.contains(event.target) || event.target.closest('a, [data-utility]')) menu.open = false; });
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || target.pathname !== location.pathname || !target.hash) return;
    const section = document.getElementById(decodeURIComponent(target.hash.slice(1)));
    if (!section) return;
    event.preventDefault();
    history.replaceState(null, '', location.pathname + location.search + target.hash);
    section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    if (target.hash === '#main') { section.tabIndex = -1; section.focus({ preventScroll:true }); }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    menus.filter(menu => menu.open).forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
}


bindInteractions();bindNavigation();
const toc=document.querySelector('.journal-contents details');if(toc){const media=matchMedia('(max-width:760px)');const adapt=()=>{toc.open=!media.matches};adapt();media.addEventListener('change',adapt);}
})();
